import TopMerchantsBarChart from './TopMerchantsBarChart';

export default TopMerchantsBarChart;
